var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4 btn tertiary btn-misc px-4",on:{"click":function($event){return _vm.$modal.show('read-terms-modal', {
            data: {},
        })}}},[_c('span',{staticClass:"mr-2"},[_vm._v("Terms & Conditions")]),_c('i',{staticClass:"far fa-info"})])
}
var staticRenderFns = []

export { render, staticRenderFns }